import React, { useState, useEffect, ReactNode, useContext, useCallback } from 'react';
// import { addLog } from './redux/consoleSlice'; // Update with your actual path
import { Severity , addLog } from '../services/redux/consoleSlice';
import { useAppDispatch } from '../services/redux/hooks';

export interface ErrorContextType {
  error: boolean;
  showError: (errorMessage: string, severity: number) => void;
}

const ErrorContext = React.createContext<ErrorContextType | undefined>(undefined);


interface ErrorProviderProps {
  children: ReactNode;
}

const ErrorProvider: React.FC<ErrorProviderProps> = ({ children }) => {
    const [error, setError] = useState<boolean>(false);
    const dispatch = useAppDispatch(); // Use the Redux dispatch function

    const showError = useCallback((errorMessage: string, severity: number) => {
        setError(true);
        // Dispatch the action to Redux
        dispatch(addLog({message: errorMessage, severity: severity}));
        //add to the console too
        // console.error(errorMessage);
        setTimeout(() => setError(false), 5000);
    }, [dispatch]);

    const handleError = (errorEvent: ErrorEvent | PromiseRejectionEvent) => {
        console.log('got an error',errorEvent);
        if (errorEvent instanceof ErrorEvent) {
            showError(errorEvent.message, Severity.Error);
        } else {
            showError((errorEvent.reason as Error).message, Severity.Error);
        }
    };

    useEffect(() => {
        window.addEventListener('error', handleError);
        window.addEventListener('unhandledrejection', handleError);

        return () => {
            window.removeEventListener('error', handleError);
            window.removeEventListener('unhandledrejection', handleError);
        };
    }, [handleError]);

    return (
        <ErrorContext.Provider value={{ error, showError }}>
            {children}
        </ErrorContext.Provider>
    );
};

export default ErrorProvider;

// Custom hook to access the ErrorContext value
export const useErrorContext = (): ErrorContextType => {
  const context = useContext(ErrorContext);
  if (context === undefined) {
    throw new Error('useErrorContext must be used within an ErrorProvider');
  }
  return context;
};
  